import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import SendMessageService from '../../../views/app/common/SendMessageService';
import { appActions } from '../../../store/modules/app';
import { REX_PHONE } from '../../../lib/rex';

class SendMessageServiceContainer extends Component {
  /**
   *  문자 서비스 발송을 위해
   *  수신자 정보와 관리자 권한체크하기
   */
  prepareSendMessageService = (data) => {
    const { prepareSendMessageService } = this.props;
    const { cellPhone } = data;

    /**
     *  핸드폰 번호 정규식 체크
     */
    if (!REX_PHONE.test(cellPhone)) {
      message.error('문자 서비스 발송을 할 수 없는 전화번호입니다.');
      return;
    }

    prepareSendMessageService(data);
  };

  render() {
    return <SendMessageService {...this.props} prepareSendMessageService={this.prepareSendMessageService} />;
  }
}

const mapDispatchToProps = {
  prepareSendMessageService: appActions.prepareSendMessageService,
};

export default connect(null, mapDispatchToProps)(SendMessageServiceContainer);
